export const getEsicExempted = ()=>([
  {id: 1, title: "Yes - ESIC Not Considered"},
  {id: 0, title: "No - ESIC Will Considered"}
])
